var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.813113 0.467237C1.00837 0.288713 1.32496 0.288713 1.52022 0.467237L6 4.56302L10.4798 0.467237C10.6751 0.288713 10.9916 0.288713 11.1869 0.467237C11.3821 0.645761 11.3821 0.935212 11.1869 1.11374L6.35353 5.53278C6.15827 5.71131 5.84173 5.71131 5.64647 5.53278L0.813113 1.11374C0.617853 0.935212 0.617853 0.645761 0.813113 0.467237Z",
    fill: "#847577"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.3ce5d4757d88ee30143e30ea5655530d.svg";
export { ForwardRef as ReactComponent };